/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Will_Get_Back_To_You_ShortlyInputs */

const en_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`will get back to you shortly.`)
};

const es_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se pondrá en contacto contigo a la brevedad.`)
};

const fr_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`reviendra vers vous rapidement.`)
};

const de_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wird sich in Kürze bei dir melden.`)
};

const ja_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`からまもなく折り返しご連絡いたします。`)
};

const zh_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将很快回复您。`)
};

const ar_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيرد عليك قريباً.`)
};

const id_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`akan segera menghubungi Anda kembali.`)
};

const it_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ti ricontatterà al più presto.`)
};

const ru_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`скоро с вами свяжется.`)
};

const pt_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrará em contato com você em breve.`)
};

const ko_will_get_back_to_you_shortly = /** @type {(inputs: Will_Get_Back_To_You_ShortlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에서 곧 연락을 드릴 것입니다.`)
};

/**
* | output |
* | --- |
* | "will get back to you shortly." |
*
* @param {Will_Get_Back_To_You_ShortlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const will_get_back_to_you_shortly = /** @type {((inputs?: Will_Get_Back_To_You_ShortlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Will_Get_Back_To_You_ShortlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_will_get_back_to_you_shortly(inputs)
	if (locale === "es") return es_will_get_back_to_you_shortly(inputs)
	if (locale === "fr") return fr_will_get_back_to_you_shortly(inputs)
	if (locale === "de") return de_will_get_back_to_you_shortly(inputs)
	if (locale === "ja") return ja_will_get_back_to_you_shortly(inputs)
	if (locale === "zh") return zh_will_get_back_to_you_shortly(inputs)
	if (locale === "ar") return ar_will_get_back_to_you_shortly(inputs)
	if (locale === "id") return id_will_get_back_to_you_shortly(inputs)
	if (locale === "it") return it_will_get_back_to_you_shortly(inputs)
	if (locale === "ru") return ru_will_get_back_to_you_shortly(inputs)
	if (locale === "pt") return pt_will_get_back_to_you_shortly(inputs)
	return ko_will_get_back_to_you_shortly(inputs)
});